/* Ghost kiwi variant — translucent, wavy bottom, no feet. */

import type { KiwiPalette } from "../kiwiPalettes";

export function renderGhost(p: KiwiPalette) {
  return (
    <>
      {/* Ghost body — rounded top, wavy bottom */}
      <path d="M12 4H20V6H24V8H26V20H24V22H22V24H20V22H18V24H16V22H14V24H12V22H10V24H8V22H6V8H8V6H12V4Z" fill={p.body} opacity={0.7} />
      {/* Inner glow */}
      <rect x="20" y="8" width="2" height="2" fill={p.highlight} opacity={0.15} />
      <rect x="22" y="10" width="2" height="2" fill={p.highlight} opacity={0.1} />
      {/* Beak — ghostly */}
      <path d="M4 10H6V12H4V10ZM2 12H4V14H2V12ZM4 14H6V16H4V14Z" fill={p.beak} opacity={0.6} />
      {/* Tuft — wispy */}
      <path d="M10 2H12V4H10V2ZM8 0H10V2H8V0Z" fill={p.body} opacity={0.4} />
      {/* Ghost eyes — hollow circles */}
      <rect x="10" y="8" width="4" height="4" fill={p.eyeBg} />
      <rect x="11" y="9" width="2" height="2" fill={p.pupil} opacity={0.8} />
      <rect x="16" y="8" width="4" height="4" fill={p.eyeBg} />
      <rect x="17" y="9" width="2" height="2" fill={p.pupil} opacity={0.8} />
    </>
  );
}
